/** Event tile's issued-ticket scalar. The tile remains its navigation target. */

import { formatNumber } from "@mhmo91/rx";
import { SchmancyElement, schmancyElement } from "@mhmo91/schmancy/mixins";
import { css, html, type TemplateResult } from "lit";
import { property } from "lit/decorators.js";
import { LocalizeMixin } from "../i18n/localize.ts";
import type { EventSaleStats } from "./stats.state.ts";

@schmancyElement("event-sale-progress")
export class EventSaleProgress extends LocalizeMixin(SchmancyElement) {
	static styles = [
		css`
			:host {
				display: block;
			}
		`,
	];

	@property({ type: Object }) stats!: EventSaleStats;

	override render(): TemplateResult {
		return html`
			<div class="flex items-baseline gap-1">
				<schmancy-typography type="body" token="md" class="tabular-nums">
					${formatNumber(this.stats.sold, this.locale)}
				</schmancy-typography>
				<schmancy-typography type="label" token="sm" class="text-surface-onVariant">
					${this.t("admin.events.console.ticketsIssuedLabel")}
				</schmancy-typography>
			</div>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"event-sale-progress": EventSaleProgress;
	}
}
